import Axios from 'axios'

const axios = Axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  }
})

export const getContent = async (url: string): Promise<unknown> => {
  const response = await axios.get(url)
  return response.data
}

const fetchCompanyPolicy = async (companyPolicy: {
  language: string;
  html_url: string;
  locale: string;
}): Promise<Policy> => {
  const html = await getContent(companyPolicy.html_url) as string
  return {
    html,
    language: companyPolicy.language,
    locale: companyPolicy.locale
  }
}

export interface Policy {
  html: string;
  language: string;
  locale: string;
}

export const hasContent = (policy: Policy) => {
  return !!policy.html
}

export const hasLocale = (policy: Policy) => {
  return !!policy.locale
}

export const hasLanguage = (policy: Policy) => {
  return !!policy.language
}

export const convertPolicies = async (companyPolicies: {
  html_url: string;
  language: string;
  locale: string;
}[]): Promise<Policy[]> => {
  const policyPromises = companyPolicies.map(fetchCompanyPolicy)
  const policies = await Promise.all(policyPromises)
  return policies
}
